<template>
  <div class="season cricket-stats">
    <cricket-coverage 
      :showVsTeam="false"
      @coverageSelected="onCoverageSelected()"></cricket-coverage>
    <loading-state :state="state"></loading-state>
    <div v-if="stats">

      <div class="head-info" v-if="stats.last_updated_time">
        <p class="silent">Updated on {{stats.last_updated_time | simpleDateTimeString}}</p>
      </div>

      <div>
        <div class="stats-box">
          <div class="item">
            <div class="number">{{stats.matches}}</div>
            <div class="label">Matches</div>
          </div>
          <div class="item">
            <div class="number">{{stats.result.won}}</div>
            <div class="label">Won</div>
          </div>
          <div class="item">
            <div class="number">{{stats.result.lost}}</div>
            <div class="label">Lost</div>
          </div>
          <div class="item">
            <div class="number">{{stats.first_batting}}</div>
            <div class="label">Bat 1<sup>st</sup> </div>
          </div>
        </div>
      </div>

      <div class="sub-menu sticky fixleft" v-if="sections.length > 1">
        <ul>
          <li
            v-for="section in sections" :key="section.key"
            :class="{active: section.value == activeSection.value}"
            @click="activeSection = section">{{section.value | capitalise}}</li>
        </ul>
      </div>
      
      <team-performance-stats
        v-if="activeSection.isStats"
        :teamKey="teamKey"
        :stats="this.stats"
      ></team-performance-stats>

      <team-performance-best
        v-if="activeSection.isBest"
        :teamKey="teamKey"
        :stats="this.stats"
      ></team-performance-best>

      <team-performance-top-players
        v-if="activeSection.isTopPlayers"
        :teamKey="teamKey"
        :stats="this.stats"
      ></team-performance-top-players>

      <team-matches
        v-if="activeSection.isUpcomingMatches"
        name="Upcoming Matches"
        :teamKey="teamKey"
        :matches="this.stats.upcoming_matches"
      ></team-matches>

      <team-matches
        v-if="activeSection.isPreviousMatches"
        name="Past Matches"
        :teamKey="teamKey"
        :matches="this.stats.previous_matches"
      ></team-matches>

    </div>
  </div>
</template>
<script>
import Utils from '@/utils'
import { Enum } from '@/helpers/enum'
import { DataState, AppState } from '@/state'

import  TeamPerformanceStats  from '@/components/cricket/TeamPerformanceStats'
import  TeamPerformanceBest  from '@/components/cricket/TeamPerformanceBest'
import  TeamPerformanceTopPlayers  from '@/components/cricket/TeamPerformanceTopPlayers'
import  TeamMatches  from '@/components/cricket/TeamMatches'

import { CricketTeamPerformance } from '@/models/cricket/performance'
import { CricketTeam } from '@/models/cricket/team'
import { CricketCoverage } from '@/models/cricket/core'


export const PerformanceViewSection = new Enum({
  Stats: 'stats',
  Best: 'best',
  TopPlayers: 'top players',
  UpcomingMatches: 'Upcoming Matches',
  PreviousMatches: 'Past Matches',
})


export default {
  components : {
    'TeamPerformanceStats': TeamPerformanceStats,
    'TeamPerformanceBest': TeamPerformanceBest,
    'TeamPerformanceTopPlayers': TeamPerformanceTopPlayers,
    'TeamMatches': TeamMatches,
  },
  data () {
    return {
      teamKey: this.$route.params.key,
      stats: null,
      state: DataState.newLoading(),
      activeSection: PerformanceViewSection.Stats,
      sections: [],
    }
  },
  watch: {
    '$route' (to, from) {
      const fromPageKey = this.createPageKey(from.params, from.query)
      const toPageKey = this.createPageKey(to.params, to.query)
      if (fromPageKey !== toPageKey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    createPageKey (params, query) {
      let key = [params.key, params.board, params.competition]
      if (params.year) {
        key.push(params.year)
      }

      if (query.vsTeam) {
        key.push(query.vsTeam)
      }
      return key.join(',')
    },

    onViewOpenned () {
      const selected = CricketCoverage.State.selected

      this.teamKey = this.$route.params.key
      selected.board = this.$route.params.board
      selected.competition = this.$route.params.competition
      selected.year = this.$route.params.year
      selected.vsTeam = this.$route.query.vsTeam

      AppState.updateActivePage(`cricket_team_${this.teamKey}_performance`)

      const selectedCoverage = CricketCoverage.State.selected
      const selectedTeam = CricketTeam.State.selected

      this.state.changeToLoading()
      CricketTeamPerformance.fetch(selectedTeam, selectedCoverage).then(stats => {
        this.stats = stats
        this.state.changeToLoaded()
        this.onDataReady()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    prepareToReopen () {
      this.teamKey = null
      this.stats = null
    },

    refreshView () {

    },

    onDataReady () {
      let newSections = [
        PerformanceViewSection.Stats,
        PerformanceViewSection.Best,
        PerformanceViewSection.TopPlayers,
        PerformanceViewSection.UpcomingMatches,
        PerformanceViewSection.PreviousMatches
      ]

      this.sections = newSections
      this.activeSection = this.sections[0]
    },

    onCoverageSelected () {
      const selected = CricketCoverage.State.selected
      this.$router.push(selected.buildUrl('cricketTeamPerformance', this.teamKey))
    }
  }
}
</script>
